<template>
    <v-dialog persistent :value="value" max-width="600px">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ $t('deny_kulturplatz') }}</span>
            </v-card-title>

            <v-card-text>
                <LabelField :label="$t('deny_kulturplatz_reason_label')">
                    <v-textarea v-model="reason" outlined dense />
                </LabelField>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="no">{{ $t('cancel') }}</v-btn>
                <v-btn color="action" text @click="yesWithMail">{{ $t('deny_kulturplatz_with_mail') }}</v-btn>
                <v-btn color="action" text @click="yes">{{ $t('deny_kulturplatz') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'UnbublishDialog',

    props: {
        value: Boolean,
    },

    data() {
        return {
            reason: '',
        };
    },

    methods: {
        no() {
            this.$emit('no');
            this.$emit('input', false);
        },

        yes() {
            this.$emit('yes', { withMail: false });
            this.$emit('input', false);
        },
        yesWithMail() {
            this.$emit('yes', { withMail: true, reason: this.reason });
            this.$emit('input', false);
        },
    },
};
</script>
